import { render, staticRenderFns } from "./TransferInFee.vue?vue&type=template&id=c355a610&"
import script from "./TransferInFee.vue?vue&type=script&lang=js&"
export * from "./TransferInFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports